<template>
  <section>
    <b-loading :is-full-page="isFullPage" :active.sync="isLoading"></b-loading>
    <b-modal :active.sync="isTermModalActive" :width="640" scroll="keep">
      <section class="terms-content" v-html="htmlText"></section>
      <footer class="terms-footer">
        <b-button
          size="is-large"
          @click.prevent="handleTermsConfirmation"
          aria-label="Li os termos e concordo"
          native-type="button"
          type="is-primary"
          >Li e concordo</b-button
        >
      </footer>
    </b-modal>
  </section>
</template>

<script>
import config from "config";
import API from "../services/http";

export default {
  data() {
    return {
      htmlText: "",
      isTermModalActive: false,
      isLoading: false,
      isFullPage: true,
    };
  },
  methods: {
    open(city = "SAO") {
      this.getTerms(city).then(() => {
        this.isTermModalActive = true;
      });
    },
    getTerms(city) {
      this.isLoading = true;

      return API.get(`${config.ZUL_API_URL}/terms`, {
        headers: {
          "X-City": city,
        },
      })
        .then((response) => {
          this.htmlText = response.data.text;
        })
        .catch(() => {
          this.$toast.open({
            message: "Não foi possível carregar os termos de uso.",
            type: "is-danger",
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    handleTermsConfirmation() {
      this.$emit("onAccept");
      this.isTermModalActive = false;
    },
  },
};
</script>
<style lang="scss">
.terms-content {
  background-color: #fff;
  padding: 1.5rem;
}

.terms-content p {
  font-size: 15px;
  line-height: 25px;
  margin-bottom: 20px;

  &:first-child {
    margin-top: 20px;
  }
}

.terms-content h2 {
  font-size: 24px;
  font-weight: 600;
  line-height: 30px;
  padding-bottom: 15px;
  border-bottom: 2px solid rgb(242, 242, 247);
  margin-bottom: 15px;
}

.terms-footer {
  position: sticky;
  bottom: 0;
  height: 100px;
  width: 100%;
  background-color: white;
  z-index: 2;

  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-content {
  position: relative;
}
</style>
